import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import DefaultLayout from "../layouts/Default/index";
import axios from 'axios';

import { messaging } from "../../src/helpers/firebase-config";
import { getToken, onMessage } from "firebase/messaging";
import { updateFcmTokenAsync } from "../api/profile";

// layouts
import NonAuthLayout from "../layouts/NonAuth/index";
import { AuthProtected } from "./AuthProtected";

import { publicRoutes, privateRoutes } from "./allRoutes";
import { Alert, Button, UncontrolledTooltip } from "reactstrap";

import { SignalRProvider } from "../components/SignalRContext";

import { createSelector } from "reselect";
import { useRedux } from "hooks";
import { Utils } from "helpers/utils";
import { setIsFakeSmsMode } from "../redux/profile2/p2_reducer";
import { loadThirdApiUrl, setViewpostSize } from "../redux/actions";
import packageJson from "../../package.json";
import { APIClient } from "api/apiCore";
import * as urls from "../api/urls";
import ChangeViewAs from "components/ChangeViewAs";
import WpTagToolBox from "components/FloatingToolbox";
import { useDialog } from "../DialogProvider";
// import SignalRListener from "../components/SignalRListener";


const Index = (props: any) => {
  const { dispatch, useAppSelector } = useRedux();
  const errorData = createSelector(
    (state: any) => state.Layout,
    (state: any) => state.Profile2,
    (state, p2) => ({
      chatConnectError: state.chatConnectError,
      isViewAs: p2.isViewAs,
      viewAsUserName: p2.viewAsUserName
    })
  );

  const { chatConnectError, isViewAs, viewAsUserName } = useAppSelector(errorData);
  const navigate = useNavigate();
  const onClick = async () => {
    try {
      const model = {
        username: "testuser",
        password: "password123"
      };
      const response = await fetch('https://localhost:7136/post-fake-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(model)
      });

      //console.log(response);

      const data = await response.json();
      //console.log('fetch = ');
      //console.log(data); // { message: "Faked login pass" }

      //console.log('1');

      axios.defaults.baseURL = "https://localhost:7136";
      const response2 = await axios.post('/post-fake-login', model, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      //console.log('2');
      //console.log('axios response');
      // Optionally, handle the response
      if (response.status === 200) {
        //console.log(response2.data); // The response data from your API
      } else {
        console.error('Error:', response.status);
      }



      return false;
    } catch (e) {
      console.error(e);
    }
  }

  const dialog = useDialog();
  const onClick2 = async (no: number) => {
    //console.log('publicRoutes:', publicRoutes);
    // const result = await dialog.confirm("Do you want to continue?", "Confirmation");
    // console.log("User chose:", result ? "OK" : "Cancel");
    // console.log('confirm pass start');
    if (no == 1) {
      // console.log('confirm pass show');
      const ok = await dialog.showConfirmPassword({ title: "Please confirm your password", apiUrl: "/api/auth/verify" });
      // console.log('confirm pass ' + ok);
    } else if (no == 2) {
      // console.log('show perm show');
      const ok2 = await dialog.showPermConfig({ permName: "การมองเห็นหมวด ลูกค้า", permKey: "xyz", defaultAllow: true, entryId: 8 });
      // console.log('show perm = ' + ok2);
    }

    // if (ok) {
    //   // API returned success and dialog closed with true
    //   console.log("confirmed: proceed");
    //   // proceed to actual action (delete etc.)
    // } else {
    //   // cancelled or verification failed
    //   console.log("not confirmed");
    // }

    // console.log('hello world2');
    // const ok2 = await dialog.showPermConfig({ permName: "การมองเห็นหมวด ลูกค้า", permKey: "xyz", defaultAllow: true, entryId:8 });
    // console.log('hello world');
    // console.log('ok2:', ok2);
  }

  const saveTokenToServer = async () => {
    try {
      if (Utils.IsViewAs()) return;
      let currentToken = localStorage.getItem('ftk');
      if (!currentToken) {
        //console.log('No token stored');
        return;
      }
      // console.log('saveTokenToServer');
      let response = await updateFcmTokenAsync(currentToken);
      // console.log('await updateFcmTokenAsync(currentToken):', response);

      if (response.status === 409) {
        //console.log("Already subscribed");
      }
      let json = JSON.parse(await response.text());
      // console.log('updateFcmTokenAsync:', json);
      if (json.needToRefreshToken) { // have to refresh token
        // console.log('need to refresh tokne');
        // console.log('current token = ' + currentToken);
        await Utils.GetFCMToken(false, true);
        let freshToken = localStorage.getItem('ftk') as string;
        // console.log('fresh token = ' + freshToken);
        response = await updateFcmTokenAsync(freshToken);
        json = JSON.parse(await response.text());
        // console.log('re-subscribe done:' , json);
      }
      // console.log('saveTokenToServerRs:', json);
      dispatch(setIsFakeSmsMode(json.apiInfo.fakeSms));
    } catch (e) {
      const er = e as Error;
      if (er.message == "Failed to fetch") {
        // connection to server is lose
      } else {
        alert((e as Error).message);
      }
    }
  }

  // generate fcm token
  useEffect(() => {
    localStorage.setItem("did4", Utils.GenerateDeviceId());
    Utils.GetFCMToken(false).then(() => { saveTokenToServer() }).catch((e) => {
      const ex = e as Error;
      if (ex.message == 'Messaging: The notification permission was not granted and blocked instead. (messaging/permission-blocked).') {
        console.error(ex);
      } else if (ex.message == "Failed to execute 'subscribe' on 'PushManager': Subscription failed - no active Service Worker") {
        console.error(ex);
      } else {
        alert(ex.message);
      }
    });

    // Set up foreground message listener
    onMessage(messaging, (payload) => {
      // console.log("Foreground message received:", payload);
      var title = payload?.notification?.title || 'No Title';
      var body = payload?.notification?.body || 'No Body';
      //alert('Foreground Receive ' + title);
      // var icon = 'xxx';
      const options = {
        body: body,
        // icon: icon,
      };
      // เปลี่ยนเป็นไม่ส่งไป background เพราะในมือถือ ขึ้นซ้อนสองครั้ง
      const isAndroid = /Android/i.test(navigator.userAgent);
      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        // Send a message to the service worker
        navigator.serviceWorker.controller.postMessage({
          type: 'SHOW_NOTIFICATION',
          title: title + '(foreground)',
          options: options
        });
      } else {
        // Fallback for browsers that allow direct Notification API usage
        if (title != 'No Title'){
          new Notification(title + '(fore)', options);
        }
      }
      // Show notification here if desired
      // badge
      if (payload.data && payload.data.badge) {
        try {
          const badgeCount = parseInt(payload.data.badge, 10);
          // Check if the browser supports app badges
          if ('setAppBadge' in navigator) {
            navigator.setAppBadge(badgeCount).then(() => {
              // console.log(`Badge set to ${badgeCount}`);
              // alert(`Badge set to ${badgeCount}`);
            }).catch((error) => {
              console.error('Error setting badge:', error);
            });
          } else {
            //console.log('App badges are not supported in this browser.');
          }
        } catch (e) {
          console.error(e);
          alert((e as Error).message);
        }
      }
    });
  }, []);

  useEffect(() => {
    // console.log('dispatch(loadThirdApiUrl());');
    dispatch(loadThirdApiUrl());
  }, []);

  // return (
  //   <React.Fragment>
  //     <button onClick={onClick2} style={{ display: "" }}>Hello</button>
  //   </React.Fragment>
  // );

  const [appVersion, setAppVersion] = useState(localStorage.getItem("appVersion"));

  const hasNewVersion = appVersion != packageJson.version;

  const reloadCache = async () => {
    localStorage.setItem("appVersion", packageJson.version);
    setAppVersion(packageJson.version);
    if ('serviceWorker' in navigator) {
      // Get active service worker registration
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        // Unregister the service worker
        await registration.unregister();
        // Clear all caches
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((cache) => caches.delete(cache)));
      }
      // Reload the page to fetch the latest content
      window.location.reload();
    }
  }

  // const onClickSwitchBack = async () => {
  //   try {
  //     const api = new APIClient();
  //     api.fnPostForm(urls.CHANGE_TO_CVIEW, { toUserId: null })
  //       .then((rs) => {
  //         if (rs.success) {
  //           //navigate('/auth-login');
  //           window.location.reload();
  //           // console.log('rs:', rs);  
  //         } else {
  //           alert(rs.message);
  //         }
  //       })
  //       .catch((error) => { });
  //   } catch (e) {
  //     console.error(e);
  //     alert((e as any).message);
  //   }
  // }
  const isDev = Utils.IsLocalHost();
  const getBootstrapBreakpoint = (width: number): "xs" | "sm" | "md" | "lg" | "xl" | "xxl" => {
    if (width >= 1400) return "xxl";
    if (width >= 1200) return "xl";
    if (width >= 992) return "lg";
    if (width >= 768) return "md";
    if (width >= 576) return "sm";
    return "xs";
  };
  const [bootStrapBreak, setBootStrapBreak] = useState<string>("");
  const [vWidth, setVWidth] = useState<number>(0);
  useEffect(() => {
    const updateBreakpoint = () => {
      const width = window.innerWidth;
      const breakpoint = getBootstrapBreakpoint(width);
      setBootStrapBreak(breakpoint);
      setVWidth(width);
      dispatch(setViewpostSize(width, breakpoint));
    };

    updateBreakpoint(); // initial
    window.addEventListener("resize", updateBreakpoint);

    return () => {
      window.removeEventListener("resize", updateBreakpoint);
    };
  }, []);

  const location = useLocation();

  return (
    <React.Fragment>
      {isDev && (<span className="badge badge-success badge-grid-size text-red">{bootStrapBreak}-{vWidth}| {location.pathname}</span>)}
      {/* <button onClick={() => onClick2(1)} style={{ display: "" }}>H1</button>
      <button onClick={() => onClick2(2)} style={{ display: "" }}>H2</button> */}
      {/* <span>{packageJson.version}</span> */}

      {/* {hasNewVersion && (
        <button id="btnReload" className="btn btn-warning" type="button" style={{ width:"100%" }} onClick={() => reloadCache()}>พบ version ใหม่ ({packageJson.version}) กดเพื่ออัปเดต</button>
      )} */}

      <div className="alert alert-danger text-center text-truncate"
        style={{
          position: "fixed", zIndex: 100000, backgroundColor: "rgba(255, 0, 0, 0.1)", border: "solid 1px red", width: "100%",
          paddingTop: "0px", fontSize: "0.9em", paddingBottom: "0px", margin: "0px", lineHeight: "20px",
          display: isViewAs ? "" : "none"
        }}
      >
        <ChangeViewAs changeToId={null} changeToName={""}>
          {/* <span className="mdi mdi-close-box hand" onClick={onClickSwitchBack}></span> */}
          <span className="mdi mdi-close-box hand" style={{ fontSize: "1.1em" }}></span>&nbsp;
        </ChangeViewAs>
        กำลังดูมุมมองของ&nbsp;&nbsp;
        <span className="text-success">{viewAsUserName}</span>&nbsp;&nbsp;

        {/* <button id="btnSwitchBack" className="btn btn-danger" type="button" style={{ width:"100%", padding:"0px" }} onClick={() => onClickSwitchBack()}>กำลังดูมุมมองของ {viewAsUserName}</button> */}
      </div>

      <SignalRProvider>
        <Routes>
          <Route>
            {publicRoutes.map((route: any, idx: number) => (
              <Route
                path={route.path}
                element={
                  <NonAuthLayout>
                    {route.component}
                  </NonAuthLayout>
                }
                key={idx}
              />
            ))}
          </Route>

          <Route>
            {privateRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={
                  <AuthProtected routeName={route.path}>
                    {route.path === "/wpcol/:parmPostIdParent/:parmImageId" ? (
                      <>{route.component}</>
                    ) : (
                      <DefaultLayout>
                        {route.component}
                      </DefaultLayout>
                    )}
                  </AuthProtected>
                }
                key={idx}
              />
            ))}
          </Route>
        </Routes>

      </SignalRProvider>
    </React.Fragment>
  );
};

export default Index;
